<template>
  <DialogHeader class="items-center">
    <SuccessIcon />
    <DialogTitle>Payment Recorded</DialogTitle>
  </DialogHeader>

  <DialogFooter class="mt-4">
    <Button @click="close">Done</Button>
  </DialogFooter>
</template>

<script setup lang="ts">
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import { Button } from '@/components/ui/button';
import { DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};
</script>
